import { Grid } from "@mui/material";
import { useEffect, useState } from "react";

import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PendingIcon from "@mui/icons-material/Pending";
import SolarPowerIcon from "@mui/icons-material/SolarPower";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from "@mui/material";
import DefaultApiService from "../../../../infrastructure/api/default";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";
import BarChartCustom from "../../../components/shared/chart/BarChartCustom";
import PieChartCustom from "../../../components/shared/chart/PieChartCustom";

const InvestorDashboardPage = () => {
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({
    totalInvestments: 0,
    investedPlants: 0,
    totalInvestedAmount: 0,
    successfulInvestments: 0,
    pendingInvestments: 0,
    activePlants: 0,
    totalCapacityKW: 0,
    rejectedInvestments: 0,
  });
  const [investmentStatusData, setInvestmentStatusData] = useState([]);
  const [monthlyInvestmentsData, setMonthlyInvestmentsData] = useState([]);
  const [monthlyAmountData, setMonthlyAmountData] = useState([]);
  const [investmentsByProvinceData, setInvestmentsByProvinceData] = useState([]);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        
        // دریافت آمار کلان از API
        const statsRes = await DefaultApiService.getApi("SLN/Investor/InvestorDashboard/GetStatistics", {}, true);
        if (statsRes?.isSuccess && statsRes?.data) {
          setStats({
            totalInvestments: statsRes.data.totalInvestments || 0,
            investedPlants: statsRes.data.investedPlants || 0,
            totalInvestedAmount: statsRes.data.totalInvestedAmount || 0,
            successfulInvestments: statsRes.data.successfulInvestments || 0,
            pendingInvestments: statsRes.data.pendingInvestments || 0,
            activePlants: statsRes.data.activePlants || 0,
            totalCapacityKW: statsRes.data.totalCapacityKW || 0,
            rejectedInvestments: statsRes.data.rejectedInvestments || 0,
          });
        }

        // دریافت داده‌های نمودار وضعیت سرمایه‌گذاری‌ها
        const statusChartRes = await DefaultApiService.getApi("SLN/Investor/InvestorDashboard/GetInvestmentStatusChart", {}, true);
        if (statusChartRes?.isSuccess && statusChartRes?.data && statusChartRes.data.length > 0) {
          const formattedStatusData = (statusChartRes.data || []).map(item => ({
            name: item.statusName,
            value: item.count
          }));
          setInvestmentStatusData(formattedStatusData);
        } else {
          // داده‌های فیک برای نمودار وضعیت سرمایه‌گذاری‌ها
          const fakeStatusData = [
            { name: "تایید شده", value: 42 },
            { name: "در حال بررسی", value: 18 },
            { name: "رد شده", value: 5 },
            { name: "پرداخت نشده", value: 3 },
          ];
          setInvestmentStatusData(fakeStatusData);
        }

        // دریافت داده‌های نمودار ماهانه سرمایه‌گذاری‌ها
        const monthlyChartRes = await DefaultApiService.getApi("SLN/Investor/InvestorDashboard/GetMonthlyInvestmentsChart", {}, true);
        if (monthlyChartRes?.isSuccess && monthlyChartRes?.data && monthlyChartRes.data.length > 0) {
          const formattedMonthlyData = (monthlyChartRes.data || []).map(item => ({
            MonthName: `${item.monthName} ${item.year}`,
            تعداد: item.count
          }));
          setMonthlyInvestmentsData(formattedMonthlyData);
        } else {
          // داده‌های فیک برای نمودار ماهانه سرمایه‌گذاری‌ها
          const fakeMonthlyData = [
            { MonthName: "فروردین 1403", تعداد: 5 },
            { MonthName: "اردیبهشت 1403", تعداد: 7 },
            { MonthName: "خرداد 1403", تعداد: 9 },
            { MonthName: "تیر 1403", تعداد: 12 },
            { MonthName: "مرداد 1403", تعداد: 15 },
            { MonthName: "شهریور 1403", تعداد: 13 },
            { MonthName: "مهر 1403", تعداد: 18 },
            { MonthName: "آبان 1403", تعداد: 20 },
            { MonthName: "آذر 1403", تعداد: 17 },
            { MonthName: "دی 1403", تعداد: 22 },
            { MonthName: "بهمن 1403", تعداد: 25 },
            { MonthName: "اسفند 1403", تعداد: 28 },
          ];
          setMonthlyInvestmentsData(fakeMonthlyData);
        }

        // دریافت داده‌های نمودار مبلغ سرمایه‌گذاری ماهانه
        const amountChartRes = await DefaultApiService.getApi("SLN/Investor/InvestorDashboard/GetMonthlyInvestmentAmountChart", {}, true);
        if (amountChartRes?.isSuccess && amountChartRes?.data && amountChartRes.data.length > 0) {
          const formattedAmountData = (amountChartRes.data || []).map(item => ({
            MonthName: `${item.monthName} ${item.year}`,
            مبلغ: item.amount
          }));
          setMonthlyAmountData(formattedAmountData);
        } else {
          // داده‌های فیک برای نمودار مبلغ سرمایه‌گذاری ماهانه
          const fakeAmountData = [
            { MonthName: "فروردین 1403", مبلغ: 250000000 },
            { MonthName: "اردیبهشت 1403", مبلغ: 350000000 },
            { MonthName: "خرداد 1403", مبلغ: 450000000 },
            { MonthName: "تیر 1403", مبلغ: 600000000 },
            { MonthName: "مرداد 1403", مبلغ: 750000000 },
            { MonthName: "شهریور 1403", مبلغ: 650000000 },
            { MonthName: "مهر 1403", مبلغ: 900000000 },
            { MonthName: "آبان 1403", مبلغ: 1000000000 },
            { MonthName: "آذر 1403", مبلغ: 850000000 },
            { MonthName: "دی 1403", مبلغ: 1100000000 },
            { MonthName: "بهمن 1403", مبلغ: 1250000000 },
            { MonthName: "اسفند 1403", مبلغ: 1400000000 },
          ];
          setMonthlyAmountData(fakeAmountData);
        }

        // دریافت داده‌های نمودار سرمایه‌گذاری به تفکیک استان
        const provinceChartRes = await DefaultApiService.getApi("SLN/Investor/InvestorDashboard/GetInvestmentsByProvinceChart", {}, true);
        if (provinceChartRes?.isSuccess && provinceChartRes?.data && provinceChartRes.data.length > 0) {
          const formattedProvinceData = (provinceChartRes.data || []).map(item => ({
            ProvinceName: item.provinceName,
            تعداد: item.count
          }));
          setInvestmentsByProvinceData(formattedProvinceData);
        } else {
          // داده‌های فیک برای نمودار سرمایه‌گذاری به تفکیک استان
          const fakeProvinceData = [
            { ProvinceName: "تهران", تعداد: 18 },
            { ProvinceName: "اصفهان", تعداد: 14 },
            { ProvinceName: "فارس", تعداد: 12 },
            { ProvinceName: "خراسان رضوی", تعداد: 10 },
            { ProvinceName: "آذربایجان شرقی", تعداد: 9 },
            { ProvinceName: "خوزستان", تعداد: 8 },
            { ProvinceName: "مازندران", تعداد: 7 },
            { ProvinceName: "گیلان", تعداد: 6 },
            { ProvinceName: "البرز", تعداد: 5 },
            { ProvinceName: "کرمان", تعداد: 4 },
          ];
          setInvestmentsByProvinceData(fakeProvinceData);
        }
        
        setLoading(false);
      } catch (error) {
        console.error("خطا در دریافت داده‌های داشبورد:", error);
        // در صورت خطا، داده‌های فیک را نمایش می‌دهیم
        const fakeStatusData = [
          { name: "تایید شده", value: 42 },
          { name: "در حال بررسی", value: 18 },
          { name: "رد شده", value: 5 },
          { name: "پرداخت نشده", value: 3 },
        ];
        const fakeMonthlyData = [
          { MonthName: "فروردین 1403", تعداد: 5 },
          { MonthName: "اردیبهشت 1403", تعداد: 7 },
          { MonthName: "خرداد 1403", تعداد: 9 },
          { MonthName: "تیر 1403", تعداد: 12 },
          { MonthName: "مرداد 1403", تعداد: 15 },
          { MonthName: "شهریور 1403", تعداد: 13 },
          { MonthName: "مهر 1403", تعداد: 18 },
          { MonthName: "آبان 1403", تعداد: 20 },
          { MonthName: "آذر 1403", تعداد: 17 },
          { MonthName: "دی 1403", تعداد: 22 },
          { MonthName: "بهمن 1403", تعداد: 25 },
          { MonthName: "اسفند 1403", تعداد: 28 },
        ];
        const fakeAmountData = [
          { MonthName: "فروردین 1403", مبلغ: 250000000 },
          { MonthName: "اردیبهشت 1403", مبلغ: 350000000 },
          { MonthName: "خرداد 1403", مبلغ: 450000000 },
          { MonthName: "تیر 1403", مبلغ: 600000000 },
          { MonthName: "مرداد 1403", مبلغ: 750000000 },
          { MonthName: "شهریور 1403", مبلغ: 650000000 },
          { MonthName: "مهر 1403", مبلغ: 900000000 },
          { MonthName: "آبان 1403", مبلغ: 1000000000 },
          { MonthName: "آذر 1403", مبلغ: 850000000 },
          { MonthName: "دی 1403", مبلغ: 1100000000 },
          { MonthName: "بهمن 1403", مبلغ: 1250000000 },
          { MonthName: "اسفند 1403", مبلغ: 1400000000 },
        ];
        const fakeProvinceData = [
          { ProvinceName: "تهران", تعداد: 18 },
          { ProvinceName: "اصفهان", تعداد: 14 },
          { ProvinceName: "فارس", تعداد: 12 },
          { ProvinceName: "خراسان رضوی", تعداد: 10 },
          { ProvinceName: "آذربایجان شرقی", تعداد: 9 },
          { ProvinceName: "خوزستان", تعداد: 8 },
          { ProvinceName: "مازندران", تعداد: 7 },
          { ProvinceName: "گیلان", تعداد: 6 },
          { ProvinceName: "البرز", تعداد: 5 },
          { ProvinceName: "کرمان", تعداد: 4 },
        ];
        setInvestmentStatusData(fakeStatusData);
        setMonthlyInvestmentsData(fakeMonthlyData);
        setMonthlyAmountData(fakeAmountData);
        setInvestmentsByProvinceData(fakeProvinceData);
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  // کارت‌های آماری اصلی
  const statCards = [
    {
      title: "کل سرمایه‌گذاری‌ها",
      value: stats.totalInvestments.toLocaleString("fa-IR"),
      sub: "سرمایه‌گذاری انجام شده",
      color: "#1976d2",
      icon: <TrendingUpIcon />,
    },
    {
      title: "نیروگاه‌های سرمایه‌گذاری شده",
      value: stats.investedPlants.toLocaleString("fa-IR"),
      sub: "نیروگاه منحصر به فرد",
      color: "#2e7d32",
      icon: <SolarPowerIcon />,
    },
    {
      title: "مبلغ کل سرمایه‌گذاری",
      value: `${stats.totalInvestedAmount.toLocaleString("fa-IR")} ریال`,
      sub: "مجموع سرمایه‌گذاری‌ها",
      color: "#ed6c02",
      icon: <AttachMoneyIcon />,
    },
    {
      title: "سرمایه‌گذاری‌های موفق",
      value: stats.successfulInvestments.toLocaleString("fa-IR"),
      sub: "تایید شده",
      color: "#2e7d32",
      icon: <CheckCircleIcon />,
    },
    {
      title: "در انتظار تایید",
      value: stats.pendingInvestments.toLocaleString("fa-IR"),
      sub: "سرمایه‌گذاری در حال بررسی",
      color: "#9c27b0",
      icon: <PendingIcon />,
    },
    {
      title: "نیروگاه‌های فعال",
      value: stats.activePlants.toLocaleString("fa-IR"),
      sub: "دارای مجوز بهره‌برداری",
      color: "#1976d2",
      icon: <SolarPowerIcon />,
    },
    {
      title: "ظرفیت کل نیروگاه‌ها",
      value: `${stats.totalCapacityKW.toLocaleString("fa-IR")} کیلووات`,
      sub: "مجموع ظرفیت سرمایه‌گذاری شده",
      color: "#d32f2f",
      icon: <AccountBalanceIcon />,
    },
    {
      title: "سرمایه‌گذاری‌های رد شده",
      value: stats.rejectedInvestments.toLocaleString("fa-IR"),
      sub: "رد شده",
      color: "#d32f2f",
      icon: <PendingIcon />,
    },
  ];

  return (
    <Box
      sx={{
        px: { xs: 1, md: 2 },
        py: { xs: 1, md: 1.5 },
        background: "#F6F8FB",
      }}
    >
      {/* نوار بالای داشبورد */}
      <Box sx={{ mb: 1.5 }}>
        <BreadcrumbsComponent />
        <Typography variant="h5" fontWeight={700} sx={{ mt: 1 }}>
          داشبورد سرمایه‌گذار
        </Typography>
      </Box>

      {/* کارت‌های آمار */}
      <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
        {statCards.map((card, idx) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={idx >= 6 ? 3 : idx >= 4 ? 3 : 3}
            key={idx}
          >
            <Card 
              sx={{ 
                borderRadius: 3, 
                boxShadow: 1,
                transition: "all 0.3s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: 3,
                },
              }}
            >
              <CardContent sx={{ py: 1.5, px: 2, "&:last-child": { pb: 1.5 } }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                  <Avatar
                    sx={{ bgcolor: card.color, mr: 1, width: 36, height: 36 }}
                  >
                    {card.icon}
                  </Avatar>
                  <Typography fontWeight={700} fontSize={14}>
                    {card.title}
                  </Typography>
                </Box>
                <Typography fontWeight={700} fontSize={20} color={card.color}>
                  {card.value}
                </Typography>
                <Typography fontSize={13} color="text.secondary">
                  {card.sub}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* نمودارها */}
      <Grid container spacing={1.5}>
        {/* نمودار وضعیت سرمایه‌گذاری‌ها */}
        <Grid item xs={12} md={4}>
          <Card sx={{ borderRadius: 3, boxShadow: 1 }}>
            <CardHeader
              title="وضعیت سرمایه‌گذاری‌ها"
              sx={{ pb: 0, pt: 1.5, px: 2 }}
              titleTypographyProps={{ fontSize: 15, fontWeight: 600 }}
            />
            <CardContent sx={{ py: 1, px: 2 }}>
              <Box sx={{ height: 350 }}>
                {loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography>در حال بارگذاری...</Typography>
                  </Box>
                ) : investmentStatusData.length > 0 ? (
                  <PieChartCustom
                    title="توزیع سرمایه‌گذاری‌ها بر اساس وضعیت"
                    data={investmentStatusData}
                    series={["تعداد"]}
                    xAxis="StatusName"
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography color="text.secondary">
                      داده‌ای برای نمایش وجود ندارد
                    </Typography>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* نمودار میله‌ای ماهانه سرمایه‌گذاری‌ها */}
        <Grid item xs={12} md={8}>
          <Card sx={{ borderRadius: 3, boxShadow: 1 }}>
            <CardHeader
              title="نمودار ماهانه سرمایه‌گذاری‌ها"
              sx={{ pb: 0, pt: 1.5, px: 2 }}
              titleTypographyProps={{ fontSize: 15, fontWeight: 600 }}
            />
            <CardContent sx={{ py: 1, px: 2 }}>
              <Box sx={{ height: 350 }}>
                {loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography>در حال بارگذاری...</Typography>
                  </Box>
                ) : monthlyInvestmentsData.length > 0 ? (
                  <BarChartCustom
                    title="تعداد سرمایه‌گذاری‌های انجام شده به تفکیک ماه"
                    xAxis="MonthName"
                    xAxisTitle="ماه"
                    yAxisTitle="تعداد سرمایه‌گذاری"
                    data={monthlyInvestmentsData}
                    series={["تعداد"]}
                    colors={["#1976d2"]}
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography color="text.secondary">
                      داده‌ای برای نمایش وجود ندارد
                    </Typography>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* نمودار مبلغ سرمایه‌گذاری ماهانه */}
        <Grid item xs={12} md={6}>
          <Card sx={{ borderRadius: 3, boxShadow: 1 }}>
            <CardHeader
              title="نمودار مبلغ سرمایه‌گذاری ماهانه"
              sx={{ pb: 0, pt: 1.5, px: 2 }}
              titleTypographyProps={{ fontSize: 15, fontWeight: 600 }}
            />
            <CardContent sx={{ py: 1, px: 2 }}>
              <Box sx={{ height: 350 }}>
                {loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography>در حال بارگذاری...</Typography>
                  </Box>
                ) : monthlyAmountData.length > 0 ? (
                  <BarChartCustom
                    title="مبلغ سرمایه‌گذاری‌های تایید شده به تفکیک ماه"
                    xAxis="MonthName"
                    xAxisTitle="ماه"
                    yAxisTitle="مبلغ (ریال)"
                    data={monthlyAmountData}
                    series={["مبلغ"]}
                    colors={["#2e7d32"]}
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography color="text.secondary">
                      داده‌ای برای نمایش وجود ندارد
                    </Typography>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* نمودار سرمایه‌گذاری به تفکیک استان */}
        <Grid item xs={12} md={6}>
          <Card sx={{ borderRadius: 3, boxShadow: 1 }}>
            <CardHeader
              title="نمودار سرمایه‌گذاری به تفکیک استان"
              sx={{ pb: 0, pt: 1.5, px: 2 }}
              titleTypographyProps={{ fontSize: 15, fontWeight: 600 }}
            />
            <CardContent sx={{ py: 1, px: 2 }}>
              <Box sx={{ height: 350 }}>
                {loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography>در حال بارگذاری...</Typography>
                  </Box>
                ) : investmentsByProvinceData.length > 0 ? (
                  <BarChartCustom
                    title="تعداد نیروگاه‌های سرمایه‌گذاری شده به تفکیک استان"
                    xAxis="ProvinceName"
                    xAxisTitle="استان"
                    yAxisTitle="تعداد نیروگاه"
                    data={investmentsByProvinceData}
                    series={["تعداد"]}
                    colors={["#9c27b0"]}
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography color="text.secondary">
                      داده‌ای برای نمایش وجود ندارد
                    </Typography>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default InvestorDashboardPage;
